import { render, staticRenderFns } from "./UpgradeTeamLevelModal.vue?vue&type=template&id=4b380ecc&"
import script from "./UpgradeTeamLevelModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeTeamLevelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports